import React, { useEffect, useRef, useState } from 'react';
import { statusLabels } from '../../constants/alarmConstants';
import './AlarmStatusDropdown.css';

export function AlarmStatusDropdown({ alarmId, status, isOpen, onToggle, onAck, onClear, onClose }) {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);

  // When parent signals close (another dropdown opened), close internally
  useEffect(() => {
    if (!isOpen) setOpen(false);
  }, [isOpen]);

  // Focus first option when dropdown opens — same pattern as SortDropdown
  useEffect(() => {
    if (!open || !dropdownRef.current) return;
    const first = dropdownRef.current.querySelector('[role="option"]');
    first?.focus();
  }, [open]);

  function handleOpen() {
    setOpen(true);
    onToggle();
  }

  function handleClose() {
    setOpen(false);
    onClose();
  }

  function handleOptionKeyDown(e, action) {
    const items = [...dropdownRef.current.querySelectorAll('[role="option"]')];
    const idx = items.indexOf(e.currentTarget);
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      items[(idx + 1) % items.length]?.focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      items[(idx - 1 + items.length) % items.length]?.focus();
    } else if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      action();
      handleClose();
      setTimeout(() => buttonRef.current?.focus(), 0);
    } else if (e.key === 'Escape') {
      handleClose();
      setTimeout(() => buttonRef.current?.focus(), 0);
    } else if (e.key === 'Tab') {
      handleClose();
    }
  }

  return (
    <div className="sort-wrapper alarm-status-wrapper">
      <button
        ref={buttonRef}
        className={`sort-button alarm-status-button status-${status} ${open ? 'active' : ''}`}
        onClick={() => open ? handleClose() : handleOpen()}
        onKeyDown={e => {
          if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && !open) {
            e.preventDefault();
            handleOpen();
          } else if (e.key === 'Escape' && open) {
            handleClose();
          }
        }}
        aria-expanded={open}
        aria-haspopup="listbox"
        aria-label={`Alarmstatus ändern, aktuell: ${statusLabels[status]}`}
        disabled={status === 'CLEARED_ACK'}
      >
        {statusLabels[status]}
      </button>
      {open && (
        <div className="sort-dropdown alarm-status-dropdown" role="listbox" ref={dropdownRef}>
          {status === 'ACTIVE_UNACK' && (
            <div
              className="sort-option"
              role="option"
              aria-selected={false}
              tabIndex={0}
              onClick={onAck}
              onKeyDown={e => handleOptionKeyDown(e, onAck)}
            >
              Alarm bestätigen
            </div>
          )}
          {(status === 'ACTIVE_UNACK' || status === 'ACTIVE_ACK') && (
            <div
              className="sort-option"
              role="option"
              aria-selected={false}
              tabIndex={0}
              onClick={onClear}
              onKeyDown={e => handleOptionKeyDown(e, onClear)}
            >
              Alarm beheben
            </div>
          )}
        </div>
      )}
    </div>
  );
}
